var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mobileView)?_c('MobileMain'):(_vm.$route.meta.layoutStatus === 'profile')?_c('main-without-content-navbar'):_c('desktop-main')
}
var staticRenderFns = []

export { render, staticRenderFns }